const baseSize = 16;
function setRem() {
  let clientWidth = document.documentElement.clientWidth;
  let clientHeight = document.documentElement.clientHeight;
  const scale1 = clientWidth / 1920;
  const scale2 = clientHeight / 1080;
  // 屏幕小于3000
  window.sscale = clientWidth < 3000 ?scale1:scale2;
  // console.log('——窗口' + (clientWidth < 3000?'1':'2') + '比例——', window.sscale);
  // 计算实际的rem值并赋予给html的font-size
  let rootFont = baseSize * (clientWidth < 3000 ?scale1:scale2);
  if(clientWidth > 1920){
	  rootFont = 16
  }
  if(clientWidth < 1366){
	  rootFont = 12
  }
  // if (rootFont < 16) rootFont = 16;
  // if (rootFont > 18) rootFont = 18;
  document.documentElement.style.fontSize = rootFont + 'px';
}
function initRem() {
  setRem();
  window.addEventListener('resize', () => {
    setRem();
  });
}
initRem();
